module.exports = __webpack_public_path__ + "img/7.f3872354.jpg";